export default {
  'dataTable.rowsPerPage': 'Sayfa başına satır: ',
  'dataTable.rangeSeparatorText': 'arası /',
};
